<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBInvoiceStatusForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBInvoiceStatusList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBInvoiceStatusForm from './Form.vue'

export default {
  components: {
    EXSBInvoiceStatusForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbinvoicestatus/update/isLoading',
      error: 'exsbinvoicestatus/update/error',
      deleteError: 'exsbinvoicestatus/del/error',
      deleteLoading: 'exsbinvoicestatus/del/isLoading',
      created: 'exsbinvoicestatus/create/created',
      deleted: 'exsbinvoicestatus/del/deleted',
      retrieved: 'exsbinvoicestatus/update/retrieved',
      updated: 'exsbinvoicestatus/update/updated',
      violations: 'exsbinvoicestatus/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBInvoiceStatusList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbinvoicestatus/create/reset',
      deleteItem: 'exsbinvoicestatus/del/del',
      delReset: 'exsbinvoicestatus/del/reset',
      retrieve: 'exsbinvoicestatus/update/retrieve',
      updateReset: 'exsbinvoicestatus/update/reset',
      update: 'exsbinvoicestatus/update/update',
      updateRetrieved: 'exsbinvoicestatus/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbinvoicestatus ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
